var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartLeasing = function SvgCartLeasing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 8.2a.75.75 0 1 0 0 1.5h1.998a1.25 1.25 0 0 1 1.2.902l3.663 12.615a2.75 2.75 0 0 0 2.64 1.983H29.5a.75.75 0 0 0 0-1.5H15.502a1.25 1.25 0 0 1-1.2-.901l-.174-.599H29.08a2.75 2.75 0 0 0 2.596-1.841l2.1-6A2.75 2.75 0 0 0 31.18 10.7H10.789l-.15-.516A2.75 2.75 0 0 0 7.999 8.2H6Zm5.225 4 2.467 8.5h15.389a1.25 1.25 0 0 0 1.18-.837l2.1-6a1.25 1.25 0 0 0-1.18-1.663H11.225ZM17.5 30a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM27 29a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgCartLeasing;